import { API_BASE_URL } from '@/api/config';
import { InfoContainer } from '@/components/base/info-container.component';
import { SimulatedProgress } from '@/components/simulated-progress.component';
import { store } from '@/config/store';
import { useGlobalStore } from '@/stores';
import { Container } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { EventSource } from 'eventsource';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function ExternalCartCompletedPage() {
  const navigate = useNavigate();
  const { t } = useTranslation('cart');
  const [error, setError] = useState(false);
  const [docEntry, setDocEntry] = useState(null);
  const { orderId } = useParams();
  const token = store.tokenObject.value.auth?.token;
  const globalStore = useGlobalStore();
  const queryClient = useQueryClient();

  const handleOpen = () => {
    console.log('>>> Connection opened!');
  };

  const handleError = (e: Event, es: EventSource) => {
    setError(true);
    console.log('>>>', e);
    es.close();
  };

  const handleMessage = (e: MessageEvent) => {
    const {
      isOrderCreated,
      isOrderFinished,
      docNum: _docNum,
      docEntry: _docEntry,
      type,
    } = JSON.parse(e as unknown as string);
    if (_docNum && isOrderFinished) {
      setError(false);
      setDocEntry(_docEntry);
    }
  };

  useEffect(() => {
    const es = new EventSource(`${API_BASE_URL}/v1/orders/sse/${orderId}`, {
      fetch: (url, init) =>
        fetch(url, {
          ...init,
          headers: {
            ...Object.fromEntries(
              new Headers(init?.headers as HeadersInit).entries(),
            ),
            Authorization: `Bearer ${token}`,
          },
        }),
    });
    es.onopen = () => handleOpen();
    es.onerror = (e) => handleError(e, es); // Pass the EventSource instance to handleOnError
    es.onmessage = (e: MessageEvent) => handleMessage(e.data);
    return () => es.close();
  }, []);

  if (error) {
    return (
      <InfoContainer
        title={t('error.title')}
        description={t('error.description')}
        button={{
          text: t('completed.backToHome'),
          href: '/bp/c',
        }}
      />
    );
  }

  if (docEntry) {
    globalStore.resetCartDeliveryAddress();
    globalStore.resetCart();
    queryClient.invalidateQueries({ queryKey: ['cart'] });
    navigate(`/bp/c/orders/${docEntry}?success=true`);
    return <></>;
  }

  return (
    <Container
      sx={{
        width: '100%',
        mx: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <SimulatedProgress
        title={t('processing.title')}
        description={t('processing.description')}
      />
    </Container>
  );
}
